import React from 'react';
import classes from '../index.module.scss';

const QuickStatsTableHeader = ({ list }) => {
  return (
    <tr>
      {list.map(item => {
        return (
          <th 
            className={classes.No_Wrap}
            key={item}
          >
            {item}
          </th>
        )
      })}
  </tr>
  )
}

export default QuickStatsTableHeader;